import styled from 'styled-components'

import {
  Textarea,
  CriticalIcon,
  Input as PopcornInput,
} from '@buffer-mono/popcorn'

import CharacterCount from '../CharacterCount'

type ChannelFieldsContainerProps = {
  $isImageFirst?: boolean
  $isExpanded?: boolean
  $noBorder?: boolean
}

export const ChannelFieldsContainer = styled.div<ChannelFieldsContainerProps>`
  display: block;
  ${(props): string | undefined =>
    props.$isImageFirst ? 'clear: both' : undefined};
  overflow: ${(props): string => (props.$isExpanded ? 'visible' : 'hidden')};
  max-height: ${(props): number => (props.$isExpanded ? 400 : 0)}px;

  --color-border-neutral: var(--color-border-subtle);

  transition: max-height 400ms ease-in-out, opacity 400ms ease-in-out,
    // Here we add differently timed transitions of border-width
    // When expanding, we want the border to be visible almost immediately
    // When collapsing, we want to wait for the collapse to almost finish, then hide the border
    ${(props): string =>
        props.$isExpanded
          ? 'border-width 100ms linear 50ms'
          : 'border-width 100ms linear 300ms'};

  ${(props): string =>
    props.$noBorder
      ? ''
      : `&:not(:empty) {
    border-top: ${
      props.$isExpanded
        ? `1px solid var(--color-border-subtle)`
        : `0px solid var(--color-border-subtle)`
    };
  }`};
`

export const Wrapper = styled.div`
  padding: 4px 16px 12px;
`

export const FieldWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  margin-top: 8px;
`

export const Label = styled.label`
  position: relative;
  font-weight: 500;
  font-size: 12px;
  color: var(--color-text-neutral);
  min-width: 130px;
`

export const Input = styled(PopcornInput)`
  flex: 1 1 0;
  box-sizing: border-box;

  font-size: var(--font-size-body-sm);
  height: 32px;
  outline: none;
`

export const ChannelFieldCharacterCount = styled(CharacterCount)`
  display: inline-block;
  border-radius: 4px;
  padding: 3px 3px;
  line-height: 12px;
  position: absolute;
  bottom: ${(props) => (props.count > props.maxCount ? '30px' : '10px')};
  right: 6px;
`

export const FirstCommentWrapper = styled.div`
  flex-grow: 1;
  position: relative;
  line-height: 0;
`

export const FirstCommentTextAreaWrapper = styled(Textarea)`
  max-height: 144px;
  padding-right: 15px;
  line-height: 25px;
`

export const StyledCriticalIcon = styled(CriticalIcon)`
  margin-right: 4px;
`
